import React from 'react';
import {Form, Input, Modal} from 'antd';
import {newPasswordNotSameValidator, passwordStrengthValidator} from '../../utils/regexp.js';

const FormItem = Form.Item;

class EditPassword extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.checkPass2 = this.checkPass2.bind(this);
        this.checkNewPwd = this.checkNewPwd.bind(this);
    }

    checkNewPwd(rule, value, callback) {
        newPasswordNotSameValidator(() => this.props.form.getFieldValue('originPwd'))(rule, value, (err) => {
            if (err) {
                callback(err);
                return;
            }
            passwordStrengthValidator(rule, value, callback);
        });
    }

    checkPass2(rule, value, callback) {
        const {getFieldValue} = this.props.form;
        if (value && value !== getFieldValue('newPwd')) {
            callback('两次输入密码不一致！');
        } else {
            callback();
        }
    }

    handleOk() {
        this.props.form.validateFields((err, value) => {
            const {originPwd, newPwd, newPwd2} = err;
            if (!originPwd && !newPwd && !newPwd2) {
                this.props.handleOk({
                    originPwd: value.originPwd,
                    newPwd: value.newPwd,
                    newPwd2: value.newPwd2,
                });
            }
        })
    }

    handleCancel() {
        this.props.form.setFieldsValue({
            originPwd: '',
            newPwd: '',
            newPwd2: ''
        });
        this.props.handleCancel();
    }

    componentDidMount() {
    }

    render() {
        const formItemLayout = {
            labelCol: {
                span: 7
            },
            wrapperCol: {
                span: 14
            }
        }
        const {getFieldDecorator} = this.props.form;
        return (
            <Modal
                title="修改密码"
                wrapClassName="vertical-center-modal"
                visible={this.props.visible}
                onOk={(e) => {
                    this.handleOk(e)
                }}
                onCancel={(e) => {
                    this.handleCancel(e)
                }}
                cancelText='返回'
            >
                <Form layout="horizontal">
                    <FormItem label="请输入原密码" {...formItemLayout}>
                        {getFieldDecorator('originPwd', {
                            rules: [{
                                required: true,
                                message: '请输入原密码'
                            }]
                        })(
                            <Input type="password" placeholder="请输入原密码"/>
                        )}
                    </FormItem>
                    <FormItem label="请输入新密码" {...formItemLayout}>
                        {getFieldDecorator('newPwd', {
                            rules: [{
                                required: true,
                                message: '请输入新密码',
                            }, {
                                validator: this.checkNewPwd,
                            }]
                        })(
                            <Input type="password" placeholder="请输入新密码"/>
                        )}
                    </FormItem>
                    <FormItem label="请再次输入新密码" {...formItemLayout}>
                        {getFieldDecorator('newPwd2', {
                            rules: [{
                                required: true,
                                message: '密码长度最少6位',
                                min: 6
                            }, {
                                validator: this.checkPass2
                            }]
                        })(
                            <Input type="password" placeholder="请再次输入新密码"/>
                        )}
                    </FormItem>
                </Form>
            </Modal>

        );
    }
}
;
export default EditPassword;


// WEBPACK FOOTER //
// ./src/routes/profile/editPassword.js